<template>
  <div class="higher-search-model">
    <!--大的查询集合-->
    <div class="big-terms-content">
      <!--大的查询集合switch-->
      <div class="big-switch-line" v-if="termsGroup.length > 1"></div>
      <div class="big-switch-contents" v-if="termsGroup.length > 1">
        <el-switch
          style="display: block"
          v-model="outOperator"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="且"
          inactive-value="or"
          active-value="and"
          @change="update"
          class="big-switch"
          inactive-text="或">
        </el-switch>
      </div>
      <!--大的查询集合条件组-->
      <div class="big-term-content" :class="termsGroup.length > 1 ? 'big-term-content-more' : 'big-term-content'" v-for="(one, i) in termsGroup" :key="i">
        <!--小的查询集合-->
        <div class="search-wrap" style="overflow:hidden;">
          <div class="small-switch-line" v-if="one.terms.length > 1"></div>
          <div class="small-switch-content" v-if="one.terms.length > 1">
            <el-switch
              style="display: block"
              v-model="one.inOperator"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="update"
              active-text="且"
              inactive-value="or"
              active-value="and"
              class="switch"
              inactive-text="或">
            </el-switch>
          </div>
          <div class="search-terms-content" :class="one.terms.length > 1 ? 'search-terms-content-more' : 'search-terms-content'">
            <div v-for="(item, index) in one.terms" :key="index" class="term-item">
              <div class="block" style="text-align: left">
                <!--级联选择器-->
                <el-cascader
                  :options="options"
                  v-model="item.selectedOptions"
                  class="first-attr"
                  @change="update(item)">
                </el-cascader>
                <!--等于还是包含等关系-->
                <el-select class="relationSelect" v-if="item.selectedOptions[0] !== 'group'" @change="update" v-model="item.relationship" placeholder="相对关系">
                  <el-option
                    v-for="item in relationOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <!--判断是什么类型 input select等-->
                <!--select-->
                <!--属性select-->
                <el-select filterable @change="update" class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'select' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.selectedOptions[0] === 'attr'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i"
                    :label="i"
                    :value="i">
                  </el-option>
                </el-select>
                <!--属性radio-->
                <el-select filterable @change="update" class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[0] !== 'source_id' && item.selectedOptions[1].split('@')[0] !== 'stage_id' && item.selectedOptions[1].split('@')[1] === 'radio' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.selectedOptions[0] === 'attr'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i"
                    :label="i"
                    :value="i">
                  </el-option>
                </el-select>
                <!--属性radio(初始来源)-->
                <el-select filterable @change="update" class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[0] === 'source_id' && item.selectedOptions[1].split('@')[1] === 'radio' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.selectedOptions[0] === 'attr'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id">
                  </el-option>
                </el-select>
                <!--属性radio(客户等级)-->
                <el-select filterable @change="update" class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[0] === 'stage_id' && item.selectedOptions[1].split('@')[1] === 'radio' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.selectedOptions[0] === 'attr'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id">
                  </el-option>
                </el-select>
                <el-select @change="update" style="margin-right: 20px;" filterable class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'select' && item.selectedOptions[0] === 'group'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i.value"
                    :label="i.label"
                    :value="i.value">
                  </el-option>
                </el-select>
                <!--input-->
                <el-input @input="update" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'input' && item.relationship !== 'empty' && item.relationship !== 'not empty'" v-model="item.value" placeholder="请输入查询内容"></el-input>
                <!--datePicker-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'datePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty'"
                  v-model="item.value"
                  type="date"
                  class="dateTimePicker"
                  @change="update"
                  placeholder="选择日期">
                </el-date-picker>
                <!--dateTimePicker-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'dateTimePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty'"
                  v-model="item.value"
                  type="datetime"
                  class="dateTimePicker"
                  @change="update"
                  placeholder="选择时间和日期">
                </el-date-picker>
                <!--addressPicker-->
                <el-cascader
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'addressPicker' && item.relationship !== 'empty' && item.relationship !== 'not empty'"
                  class="area"
                  size="large"
                  :options="addressOptions"
                  v-model="item.value"
                  @change="update">
                </el-cascader>
                <div class="remove-btn" @click="removeTermItem(index, i)" v-if="num > 1">
                  <i class="el-icon-close" title="删除当前条件"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="add-new-terms" v-if="one.terms.length > 0">
          <div class="add-new-term-btn" @click="addNewTerm(i)">
            <i class="el-icon-circle-plus-outline"></i>
            增加一个条件
          </div>
        </div>
      </div>
    </div>
    <!--增加一组条件按钮-->
    <div class="add-one-group-terms">
      <div class="add-one-group-terms-btn" @click="addNewTermGroup">
        <i class="el-icon-circle-plus-outline"></i>
        增加一组条件
      </div>
    </div>
  </div>
</template>

<script>
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { getCustomerAttributeList, getGroupList, getSourceData, getCustomerStage } from '@/api/customer.js'
import { mapGetters } from 'vuex'
export default {
  name: '',
  props: ['forSonTerms', 'allRelationship', 'allRelationshipSearch'],
  data () {
    return {
      outOperator: 'and',
      addressOptions: regionDataPlus,
      options: [
        {
          value: 'attr',
          label: '客户属性',
          children: []
        },
        {
          value: 'group',
          label: '群组',
          children: []
        }
      ],
      relationOptions: [
        {
          value: '=',
          label: '等于'
        }, {
          value: '!=',
          label: '不等于'
        }, {
          value: 'contain',
          label: '包含'
        }, {
          value: 'not contain',
          label: '不包含'
        }, {
          value: 'empty',
          label: '为空'
        },
        {
          value: 'not empty',
          label: '不为空'
        }
      ],
      relation: '',
      ifSelect: '',
      ifSelectOptions: [],
      ifInput: '',
      ifRadio: '',
      termsGroup: this.forSonTerms.termsGroup,
      search: {}
    }
  },
  watch: {
    forSonTerms: function (val) {
      this.termsGroup = val.termsGroup
    }
  },
  computed: {
    ...mapGetters([
      'getQuery'
    ]),
    num() {
      let num = 0
      for (let item of this.termsGroup) {
        num = num + item.terms.length
      }
      return num
    },
    allTerms() {
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      allTerms.termsGroup = this.termsGroup
      return allTerms
    }
  },
  methods: {
    // 传值到父组件
    update(item) {
      // 解决change报错问题
      if (typeof item !== 'undefined' && typeof item.value !== 'undefined') {
        // 如果是select或者radio的话 相对关系只有等于不等于
        if (item.selectedOptions[0] === 'attr' && item.selectedOptions[1].split('@')[1] === 'select') {
          this.relationOptions.splice(2, 4)
          item.relationship = '='
        } else {
          this.relationOptions = [
            {
              value: '=',
              label: '等于'
            }, {
              value: '!=',
              label: '不等于'
            }, {
              value: 'contain',
              label: '包含'
            }, {
              value: 'not contain',
              label: '不包含'
            }, {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not empty',
              label: '不为空'
            }
          ]
        }
        item.value = null
        let str = item.selectedOptions[1].split('@')
        for (let one of this.options) {
          for (let i in one.children) {
            if (str[0] === one.children[i].identity) {
              item.option = one.children[i].option
            }
          }
        }
        // 处理下第一属性的问题
        for (let item of this.termsGroup) {
          for (let one of item.terms) {
            let strs = one.selectedOptions[1].split('@')
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = strs[0]
          }
        }
      }
      // 传值到父组件
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      allTerms.termsGroup = this.termsGroup
      console.log('this.termsGroup', this.termsGroup)
      this.$emit('sendTerms', allTerms)
    },
    // 添加一组查询条件
    addNewTermGroup() {
      this.termsGroup.push({
        inOperator: 'and',
        terms: [
          {
            attr: 'attr',
            relationship: '',
            value: null,
            selectedOptions: ['attr', 'realname@input']
          }
        ]
      })
    },
    // 删除当前这条查询条件
    removeTermItem(index, i) {
      this.termsGroup[i].terms.splice(index, 1)
      if (this.termsGroup[i].terms.length === 0) {
        this.termsGroup.splice(i, 1)
      }
    },
    // 添加一条查询条件
    addNewTerm(i) {
      this.termsGroup[i].terms.push({
        attr: 'attr',
        relationship: '',
        value: null,
        selectedOptions: ['attr', 'realname@input']
      })
    },
    // 处理地址选择
    handleAddressChange (value) {
      console.log(value)
    },
    // 条件选择
    handleChange(value) {
      console.log(value)
    },
    // 加载
    load() {
      // 获取属性列表
      getCustomerAttributeList().then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            if (data[i].identity === 'district' || data[i].identity === 'city' || data[i].identity === 'province' || data[i].identity === 'country') {
              continue
            }
            if (data[i].identity === 'source_id') {
              getSourceData().then((res) => {
                data[i].option = []
                for (let item of res.data.data.list) {
                  data[i].option.push({
                    name: item.name,
                    id: item.id
                  })
                }
              })
            }
            if (data[i].identity === 'stage_id') {
              getCustomerStage().then((res) => {
                data[i].option = [
                  {
                    name: '未知等级',
                    id: 0
                  }
                ]
                for (let item of res.data.data) {
                  data[i].option.push({
                    name: item.name,
                    id: item.id
                  })
                }
              })
            }
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity + '@' + remainData[i].type
            remainData[i].label = remainData[i].name
          }
          remainData.push({
            label: '省市区',
            value: 'systemPcd@addressPicker'
          })
          this.options[0].children = remainData
        }
      })
      // 获取群组列表
      getGroupList(this.page, this.search, 0).then((res) => {
        if (res.data.code === 0) {
          for (let item of res.data.data.list) {
            item.label = item.name
            item.value = item.id
          }
          let option = []
          option = res.data.data.list
          console.log('nicai', option)
          this.options[1].children.push(
            {
              label: '在此群组中',
              value: 'inGroup@select',
              option: option,
              identity: 'inGroup'
            }
          )
          this.options[1].children.push(
            {
              label: '不在此群组中',
              value: 'notInGroup@select',
              option: option,
              identity: 'notInGroup'
            }
          )
          for (let one of this.forSonTerms.termsGroup) {
            for (let yi of one.terms) {
              if (yi.attr === 'group') {
                yi.option = option
              }
            }
          }
        }
      })
      if (this.allRelationship) {
        this.outOperator = this.allRelationship
      } else if (this.allRelationshipSearch) {
        this.outOperator = this.allRelationshipSearch
      }
    }
  },
  mounted() {
  },
  created() {
    this.load()
    this.update()
    console.log('ccc', this.forSonTerms)
  }
}
</script>

<style scoped>
.search-terms-content{
  width: 100%;
  margin-left: 0;
}
.search-terms-content-more{
  width: 92%;
  margin-left: 8%;
}
.big-term-content{
  width: 100%;
  margin-left: 0;
}
.big-term-content-more{
  width: 94%;
  margin-left: 6%;
}
.big-switch-contents{
  width: 6%;
  height: 64px;
  background: #fff;
  text-align: center;
}
.big-switch-contents .el-switch{
  margin-top: 0;
}
.big-switch-line{
  width: calc(3% - 1px);
  left: 3%;
}
.small-switch-content{
  width: 6%;
  height: 64px;
  background: #fff;
  font-size: 12px;
  margin-top: -30px;
  margin-left: 5px;
}
.small-switch-line{
  width: calc(4% - 1px);
  left: 4%;
  height: calc(100% - 36px);
  top: 20px;
}
.term-item{
  margin-bottom: 10px;
  margin-top: 10px;
  padding-left: 5px;
}
</style>
